<template>
  <!-- Modal terms -->
  <div
    class="modal fade show"
    id="mobile-verify-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mobileVerifyModal"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" id="close-button">&times;</button>
        </div>
        <form class="text-center mx-auto" @submit.prevent="formattedCountdownMobile !== '00:00' ? verify() : resend()">
          <img src="/img/email-verification.svg" alt="email verification" />
          <p class="modal-bottom-title mb-0" id="mobileVerifyModal">{{ $t('Telefon Numaranızı Onaylayın') }}</p>
          <div style="border-top: 1px solid #e9e9e9"></div>
          <div class="modal-body modal-body-min">
            <div class="mb-3 verify-info-field">
              <i18n path="Cep Telefonunuzu Onaylayın text" tag="span">
                <template v-slot:mobile>
                  <b class="text-dark">{{ mobile }}</b>
                </template>
              </i18n>
            </div>

            <div class="mb-2">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                :num-inputs="6"
                separator=""
                input-type="tel"
                class="justify-content-center otp-field"
                :should-auto-focus="true"
                :is-input-num="true"
                :class="{ 'invalid-otp-field': isCodeIncorrect }"
                @on-change="handleOnChange"
              />
            </div>

            <div v-if="limitMessage" class="invalid-code-field">
              {{ limitMessage }}
            </div>

            <div v-if="isCodeIncorrect" class="invalid-code-field mb-4">
              {{ $t('Doğrulama kodu hatalı. Lütfen kontrol edip tekrar deneyin') }}
            </div>

            <div class="text-center timer-field my-3">
              <div v-if="formattedCountdownMobile !== '00:00'" class="">
                {{ $t('Kalan süre') }} {{ formattedCountdownMobile }}
              </div>
            </div>
          </div>
          <div class="modal-footer border-0">
            <div class="d-flex flex-md-row flex-column w-100 gap-3">
              <mButton
                class="flex-grow-1"
                style="flex: 1"
                data-dismiss="modal"
                :button-options="backButtonOptions"
              ></mButton>

              <mButton
                class="ml-md-3 ml-0 mt-md-0 mt-3"
                style="flex: 1"
                :disabled="loading"
                :button-options="confirmButtonOptions"
              ></mButton>
            </div>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <MobileVerifiedModal />
  </div>
  <!-- /.modal -->
</template>
<script>
import UserStore from './../../stores/user';
import MobileVerifiedModal from './MobileVerified';
import InputField from './../InputField.vue';
import OtpInput from '@/components/OtpInput.vue';

export default {
  name: 'mobileVerifyModal',
  components: {
    MobileVerifiedModal,
    InputField,
    'v-otp-input': OtpInput,
  },
  props: ['mobile', 'limitMessage'],
  data() {
    return {
      backButtonOptions: {
        text: this.$t('Telefon Numarası Değiştir'),
        type: 'outline-light',
        size: 'normal',
        rightIcon: false,
        leftIcon: false,
        rounded: false,
      },
      isCodeIncorrect: false,
      code: null,
      loading: false,
      initialTime: 180,
      countdownMobile: 180,
    };
  },
  computed: {
    confirmButtonOptions() {
      return {
        text: this.formattedCountdownMobile !== '00:00' ? this.$t('Onayla') : this.$t('Yeni Kod Gönder'),
        type: 'primary',
        size: 'normal',
        rightIcon: false,
        leftIcon: false,
        rounded: false,
      };
    },
    formattedCountdownMobile() {
      const minutes = String(Math.floor(this.countdownMobile / 60)).padStart(2, '0');
      const seconds = String(this.countdownMobile % 60).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
  },
  unmounted() {
    clearInterval(this.timerMobile);
  },
  methods: {
    resetModal() {
      this.resetMobileTimer();
      this.code = null;
      this.$refs.otpInput.resetOtp();
      this.isCodeIncorrect = false;
    },
    resetMobileTimer() {
      this.stopCountdownMobile();
      this.countdownMobile = this.initialTime;

      this.startCountdownMobile();
    },
    startCountdownMobile() {
      this.timerMobile = setInterval(() => {
        if (this.countdownMobile > 0) {
          this.countdownMobile--;
        } else {
          clearInterval(this.timerMobile);
        }
      }, 1000);
    },
    stopCountdownMobile() {
      clearInterval(this.timerMobile);
    },
    handleOnChange(code) {
      this.code = code;
    },
    resend: function (isResent = false) {
      if (isResent) {
        this.loading = true;
      }
      UserStore.dispatch('resendVerificationMobile')
        .then((s) => {
          this.resetMobileTimer();
          this.loading = false;
          this.$toasted.success(this.$t('AlertMessages.Doğrulama kodu cep telefonunuza gönderildi'));
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    verify: function () {
      if (!this.code || this.code.length !== 6) {
        this.$toasted.error(this.$t('Lütfen geçerli bir doğrulama kodu giriniz'));
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const mobileNumber = '+' + this.mobile.replace(/[^0-9.]/g, '');
          UserStore.dispatch('mobileVerify', {
            code: this.code,
            mobile: mobileNumber,
          })
            .then((s) => {
              this.loading = false;
              this.isCodeIncorrect = false;
              window.document.getElementById('close-button').click();
              this.$emit('mobile-verified');
            })
            .catch((e) => {
              this.isCodeIncorrect = true;
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.timer-field {
  color: #000;

  font-size: 14px;

  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.14px;
}
.invalid-code-field {
  color: #f6576e;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.14px;
}
.verify-info-field {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.16px;
  color: #727272;
}
.modal-body {
  padding: 16px 0px 0px 0px !important;
}
.modal-content {
  padding: 16px 32px 32px 32px !important;
  @media (max-width: 768px) {
    padding: 10px !important;
  }
}
.modal-dialog {
  max-width: 674px !important;
  padding: 32px !important;
  @media (max-width: 768px) {
    padding: 8px !important;
  }
}
.modal-footer {
  padding: 0px !important;
}
.otp-field {
  padding: 28px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;

  @media (max-width: 512px) {
    padding: 10px 0px;
  }
}
.modal-bottom-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -1px;
  line-height: 32px;
  padding-top: 16px;
  padding-bottom: 16px;
}
</style>
